import React from "react";
import Footer from "../SharedComponents/Footer";
import "../../assets/stylesheets/ErrorPage.scss";
import Header from "./Header";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "react-blueprint-library";

function ErrorPage() {
  const returnToDashboard = () => {
    window.location.href = "/";
  };
  return (
    <div id="errorPage">
      <Header></Header>
      <Container>
        <Row>
          <Col lg={12}>
            <div className="error-page-img-wrapper">
              <div
                className="mm-illustration illustration-error_500"
                id="errorImg"
              ></div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="error-page-text">
              <h2>
                There was an error processing your request; <br /> please try
                again later.
              </h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <Button variant="primary" onClick={returnToDashboard}>
                Return to Dashboard
              </Button>
            </div>
          </Col>
        </Row>
        <Footer />
      </Container>
    </div>
  );
}
export default ErrorPage;
